export const SmoothScrollbarPlugin = {
  alias: "smooth-scrollbar",
  name: "smooth-scrollbar@1.0.0",
  init: function (sheet) {
    sheet.pluginData["smooth-scrollbar"] = Scrollbar.init(sheet.contents, {
      damping: 0.1,
      thumbMinSize: 20,
      renderByPixels: true,
      alwaysShowTraks: false,
      continumousScrolling: true,
    });
    sheet.originEl.addEventListener("xe_bottomsheet::open_done", SmoothScrollbarPlugin.eventListener);
  },
  destory: function (sheet) {
    sheet.pluginData["smooth-scrollbar"].destroy();
    delete sheet.pluginData["smooth-scrollbar"];
    sheet.originEl.removeEventListener("xe_bottomsheet::open_done", SmoothScrollbarPlugin.eventListener);
  },
  eventListener: function (e) {
    e.detail.contents.style.overflow = "hidden";
  }
};

export const compatiblePluginAlias = (plugin) => {
  return {
    [plugin.alias]: plugin,
  };
};

export const mergePlugins = (origins, merges) => {
  return {
    ...origins,
    ...merges,
  };
};

export default {
  SmoothScrollbarPlugin,
};
